import React from "react";
import Quote from "../components/Quote";
import BottomPipe from '../components/BottomPipe';
import EndPhaseFour from '../components/EndPhaseFour';
export default ({ isActive }) => {
  const message = 'Once medical authorities, such as the FDA, approve a medicine, doctors can begin to prescribe it for patients.';

  const defaultQuote = {
    author: '',
    position: '',
    img: null,
    quote: [message]
  }
  return (
    <div className="component hide-overflow">
      <Quote isActive={isActive} quote={defaultQuote} showQuotemark={false} />
      <BottomPipe isActive={isActive} position={'left'} />
      <EndPhaseFour isActive={isActive} />
    </div>
  );
};
